import { graphql } from 'react-relay';

export const fundsserviceAutocompleteFragment = graphql`
    fragment FundsserviceAutocomplete_autocomplete on HomeFundServiceAutocomplete {
        noResultsMessage
        furtherResultsMessage
        items (first: 1000) {
            edges {
                node {
                    fundsname
                    country
                    largeinvestmentfonds
                    tranches (first: 1000) {
                        edges {
                            node {
                                url
                                isin
                                salesadmission
                            }
                        }
                    }
                }
            }
        }
    }
`;
